import React from 'react';
import { Button } from './ui/Button';
import { Check, Clock, Shield, Quote } from 'lucide-react';
export function OfferSection() {
  const bullets = ['Guía digital completa', 'Checklist de mochila sensorial', 'Plan de acción de 60 segundos', 'Diario de disparadores', 'Tarjeta visual imprimible'];
  return <section id="oferta-final" className="bg-white pt-10 pb-6 md:pt-16 md:pb-10 px-5 scroll-mt-8" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <div className="text-center mb-10" data-id="element-120">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F0E] mb-4" data-id="element-121">
            Empieza hoy con una guía clara para el próximo momento difícil
          </h2>
          <p className="text-[1.05rem] md:text-lg text-[#6B5D4F] max-w-2xl mx-auto leading-relaxed" data-id="element-122">
            Accede al Protocolo SOS y ten a la mano una forma más calmada, clara
            y útil de responder cuando tu hijo colapsa.
          </p>
        </div>

        {/* Trust validation line */}
        <div className="text-center mb-10 py-4" data-id="element-123">
          <p className="text-base md:text-lg text-[#4A6741] font-medium italic tracking-wide leading-relaxed" data-id="element-124">
            Creado para madres que necesitan una respuesta clara en el momento
            real.
          </p>
        </div>

        <div className="bg-[#FDF8F0] rounded-[2rem] p-6 md:p-12 border-2 border-[#D4A853]/30 shadow-xl relative" data-id="element-125">
          {/* Badge */}
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#C75C3A] text-white px-6 py-1.5 rounded-full text-xs md:text-sm font-bold tracking-wide shadow-md whitespace-nowrap" data-id="element-126">
            PRECIO BETA DE LANZAMIENTO
          </div>

          <div className="text-center space-y-6 mt-4" data-id="element-127">
            <div className="py-6 flex flex-col items-center justify-center bg-white rounded-2xl border border-[#D4A853]/20 mx-auto max-w-sm" data-id="element-128">
              <div className="text-[#6B5D4F] text-sm md:text-base line-through mb-1" data-id="element-129">
                Precio Regular: $12.99
              </div>
              <div className="flex items-start justify-center text-[#C75C3A]" data-id="element-130">
                <span className="text-3xl font-bold mt-1" data-id="element-131">$</span>
                <span className="text-6xl md:text-7xl font-black tracking-tighter" data-id="element-132">
                  6.49
                </span>
              </div>
              <div className="text-[#4A6741] text-sm font-medium mt-3 bg-[#F0F4EC] px-3 py-1 rounded-full" data-id="element-133">
                Pago único • Acceso inmediato
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-[#C75C3A] font-medium text-sm md:text-base bg-[#C75C3A]/10 py-2 px-4 rounded-full w-fit mx-auto" data-id="element-134">
              <Clock className="w-4 h-4" data-id="element-135" />
              <span data-id="element-136">Disponible por las próximas 48 horas</span>
            </div>

            <div className="text-left max-w-sm mx-auto space-y-3 py-4" data-id="element-137">
              {bullets.map((bullet, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-138">
                  <Check className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-139" />
                  <span className="text-[#2D1F0E] font-medium text-[0.9rem] md:text-base" data-id="element-140">
                    {bullet}
                  </span>
                </div>)}
            </div>

            {/* Mini testimonial */}
            <div className="max-w-sm mx-auto bg-white/80 rounded-xl p-4 border border-[#D4A853]/15" data-id="element-141">
              <div className="flex items-start gap-2" data-id="element-142">
                <Quote className="w-4 h-4 text-[#D4A853] flex-shrink-0 mt-0.5" data-id="element-143" />
                <div data-id="element-144">
                  <p className="text-[#2D1F0E] text-sm md:text-[0.9rem] italic leading-relaxed" data-id="element-145">
                    Por primera vez sentí que sabía qué hacer en lugar de
                    improvisar.
                  </p>
                  <p className="text-[#6B5D4F] text-xs md:text-sm mt-1.5 font-medium" data-id="element-146">
                    — Mamá en USA
                  </p>
                </div>
              </div>
            </div>

            <div id="offer-cta" className="pt-6 space-y-5 scroll-mt-16" data-id="element-147">
              <Button fullWidth href="https://www.upreferr.com/cart/44203439128711:1" className="text-xl md:text-2xl py-6 min-h-[64px] shadow-xl" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'InitiateCheckout', {
                  content_name: 'Protocolo SOS',
                  content_ids: ['44203439128711'],
                  content_type: 'product',
                  value: 6.49,
                  currency: 'USD',
                  num_items: 1
                });
              }
            }} data-id="element-148">
                Quiero acceso inmediato
              </Button>

              <div className="flex items-center justify-center gap-2 text-sm md:text-base text-[#6B5D4F] font-medium" data-id="element-149">
                <Shield className="w-4 h-4" data-id="element-150" />
                <span data-id="element-151">Pago único • Acceso inmediato • Material en español</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}